var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-item",style:({ display: _vm.show ? '' : 'none' }),on:{"click":_vm.onRoutingJump}},[_c('img',{attrs:{"src":_vm.menu.img}}),_c('span',[_vm._v(_vm._s(_vm.menu.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }